// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import agent package modal (memo dev/36). */

.ZxHipj_hmIDXbYkQWdEW {
  padding: 4px 8px 8px;
  min-width: 380px;
}

.YfNUeDwklyU7NydNlIO_ {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 600;
  color: var(--curio-text-primary, var(--curio-text-primary));
}

.LFMAQlkDopHGjQ4o3reQ {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--curio-text-secondary, var(--curio-text-meta));
}

.oNIJQDARuilcRFedq63a input {
  font-size: 12px;
}

/* A skill's import: two ways to pick, then the review of what was picked. */
.DUbI2SJBEEeys7aFak9Y {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.cFTHU4JxEpVnKFucCdIX {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  color: var(--curio-text-primary);
}

.NrX2lZLNv0pDkPrGKPyl {
  margin-top: 12px;
  max-height: 52vh;
  overflow-y: auto;
  border: 1px solid var(--curio-border);
  border-radius: 10px;
  padding: 10px 12px;
  background: var(--curio-surface-muted);
}

.n7pO_iEFG_JKFuMljwDg + .n7pO_iEFG_JKFuMljwDg {
  margin-top: 10px;
}

.CwYNWJ57bTu1SCHg4oOE {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--curio-text-secondary, var(--curio-text-meta));
}

.VlEcG212OyGaiMJv6HPA {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: var(--curio-text-primary);
}

.RLnWrMDbIRX9vt1w71u3 {
  margin: 0;
  padding-left: 18px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--curio-text-primary);
}

.W5T4iBCoS0lPWbwR5E_m {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 6px;
}

.wOFEe7CNDAYRMrJtcv08 {
  flex: 1;
  min-width: 0;
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  padding: 5px 8px;
  font-size: 12px;
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
}

.ic6dXjiqadTjoz7dWQKO {
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 12px;
  color: var(--curio-text-primary);
}

.UoMcX8aLWgVKqaF8xbX_ {
  margin: 10px 0 0;
  font-size: 12px;
  color: var(--curio-text-primary, var(--curio-text-primary));
  background: var(--curio-surface-muted);
  border: 1px solid var(--curio-border);
  border-radius: 10px;
  padding: 8px 10px;
}

/* Inline reset for the accumulating selection: a plain text control inside the
   summary line, not a third button competing with Cancel/Import in the footer. */
.VEftfTDwMl_xXV3s9Vrj {
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: var(--curio-text-secondary);
  text-decoration: underline;
  cursor: pointer;
}

.VEftfTDwMl_xXV3s9Vrj:hover {
  color: var(--curio-text-primary);
}

.MGMZNGtP0oJCwRsTRVeA {
  margin: 10px 0 0;
  font-size: 12px;
  color: var(--curio-danger-text);
  white-space: pre-wrap;
}

.PKY1eQ0jJDq2Ce0alhwK {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}

.bRXI36W4evQPtvh9VQzG {
  border: 1px solid var(--curio-border);
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  background: var(--curio-card-bg);
  color: var(--curio-text-primary, var(--curio-text-primary));
  cursor: pointer;
}

.COkB8p4thjIQOsrwSrel {
  border: none;
  border-radius: 999px;
  padding: 6px 18px;
  font-size: 12px;
  font-weight: 600;
  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));
  color: var(--curio-text-on-dark, var(--curio-text-on-dark));
  cursor: pointer;
}

.COkB8p4thjIQOsrwSrel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/catalog/AgentImportModal.module.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,eAAe;AACjB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2DAA2D;EAC3D,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;iFACiF;AACjF;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4DAA4D;EAC5D,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Import agent package modal (memo dev/36). */\n\n.body {\n  padding: 4px 8px 8px;\n  min-width: 380px;\n}\n\n.title {\n  margin: 0 0 6px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--curio-text-primary, var(--curio-text-primary));\n}\n\n.hint {\n  margin: 0 0 12px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n}\n\n.picker input {\n  font-size: 12px;\n}\n\n/* A skill's import: two ways to pick, then the review of what was picked. */\n.pickers {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n}\n\n.pickerLabel {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.review {\n  margin-top: 12px;\n  max-height: 52vh;\n  overflow-y: auto;\n  border: 1px solid var(--curio-border);\n  border-radius: 10px;\n  padding: 10px 12px;\n  background: var(--curio-surface-muted);\n}\n\n.reviewSection + .reviewSection {\n  margin-top: 10px;\n}\n\n.reviewLabel {\n  margin: 0 0 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n}\n\n.reviewText {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--curio-text-primary);\n}\n\n.reviewList {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--curio-text-primary);\n}\n\n.nameRow {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-top: 6px;\n}\n\n.nameInput {\n  flex: 1;\n  min-width: 0;\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  padding: 5px 8px;\n  font-size: 12px;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n}\n\n.agentRow {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  font-size: 12px;\n  color: var(--curio-text-primary);\n}\n\n.summary {\n  margin: 10px 0 0;\n  font-size: 12px;\n  color: var(--curio-text-primary, var(--curio-text-primary));\n  background: var(--curio-surface-muted);\n  border: 1px solid var(--curio-border);\n  border-radius: 10px;\n  padding: 8px 10px;\n}\n\n/* Inline reset for the accumulating selection: a plain text control inside the\n   summary line, not a third button competing with Cancel/Import in the footer. */\n.clear {\n  margin-left: 6px;\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  color: var(--curio-text-secondary);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.clear:hover {\n  color: var(--curio-text-primary);\n}\n\n.error {\n  margin: 10px 0 0;\n  font-size: 12px;\n  color: var(--curio-danger-text);\n  white-space: pre-wrap;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.cancel {\n  border: 1px solid var(--curio-border);\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary, var(--curio-text-primary));\n  cursor: pointer;\n}\n\n.import {\n  border: none;\n  border-radius: 999px;\n  padding: 6px 18px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));\n  color: var(--curio-text-on-dark, var(--curio-text-on-dark));\n  cursor: pointer;\n}\n\n.import:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `ZxHipj_hmIDXbYkQWdEW`,
	"title": `YfNUeDwklyU7NydNlIO_`,
	"hint": `LFMAQlkDopHGjQ4o3reQ`,
	"picker": `oNIJQDARuilcRFedq63a`,
	"pickers": `DUbI2SJBEEeys7aFak9Y`,
	"pickerLabel": `cFTHU4JxEpVnKFucCdIX`,
	"review": `NrX2lZLNv0pDkPrGKPyl`,
	"reviewSection": `n7pO_iEFG_JKFuMljwDg`,
	"reviewLabel": `CwYNWJ57bTu1SCHg4oOE`,
	"reviewText": `VlEcG212OyGaiMJv6HPA`,
	"reviewList": `RLnWrMDbIRX9vt1w71u3`,
	"nameRow": `W5T4iBCoS0lPWbwR5E_m`,
	"nameInput": `wOFEe7CNDAYRMrJtcv08`,
	"agentRow": `ic6dXjiqadTjoz7dWQKO`,
	"summary": `UoMcX8aLWgVKqaF8xbX_`,
	"clear": `VEftfTDwMl_xXV3s9Vrj`,
	"error": `MGMZNGtP0oJCwRsTRVeA`,
	"footer": `PKY1eQ0jJDq2Ce0alhwK`,
	"cancel": `bRXI36W4evQPtvh9VQzG`,
	"import": `COkB8p4thjIQOsrwSrel`
};
export default ___CSS_LOADER_EXPORT___;
